import OrderByHeaders from "components/ordering/OrderByHeaders";

const TableAdvanced = (
    {
        items,
        itemsShow,
        buttonsTB,
        setButtonsTB,
        checkedAll,
        setCheckedAll,
        orderingRef,
    }
) => {
    const onClickAll = (e) => {
        let buttons = {...buttonsTB};
        let checkboxes = document.querySelectorAll('#data-list input[type="checkbox"]');
        if (e.target.checked) {
            setCheckedAll(true);
            buttons.delete.disabled = false;
            items.current.chosen = itemsShow.map((item) => item.id);
            checkboxes.forEach((checkbox) => {
                checkbox.checked = true;
            });
        } else {
            setCheckedAll(false);
            buttons.delete.disabled = true;
            items.current.chosen = [];
            checkboxes.forEach((checkbox) => {
                checkbox.checked = false;
            });
        }
        setButtonsTB(buttons);
    };

    const onClickCheck = (e) => {
        let id = parseInt(e.target.value);
        let buttons = {...buttonsTB};

        if (items.current.chosen.includes(id)) {
            items.current.chosen = items.current.chosen.filter((e) => e !== id);
            checkedAll && setCheckedAll(false);
        } else {
            items.current.chosen.push(id);
        }
        buttons.delete.disabled = !(items.current.chosen.length > 0);
        buttons.edit.disabled = !(items.current.chosen.length === 1);
        setCheckedAll(items.current.chosen.length === itemsShow.length);
        setButtonsTB(buttons);
    };

    const stickyHeaderStyle = {
        position: "sticky",
        top: "164px",
        backgroundColor: "white",
        zIndex: 899,
    };

    return (
        <table className="table table-striped sticky-horizontal">
            <thead>
            <tr>
                <th
                    key="-1"
                    style={{
                        width: "0.4%",
                        verticalAlign: "bottom",
                        ...stickyHeaderStyle,
                    }}
                    className="sticky-top border-bottom-sticky">
                    <input
                        className="form-check-input"
                        type="checkbox"
                        value="all"
                        onChange={onClickAll}
                    />
                </th>
                <OrderByHeaders orderingRef={orderingRef} />

            </tr>
            </thead>
            <tbody id="data-list">
            {itemsShow.map((item, index) => (
                <tr key={index} data-idx={item.id} onChange={onClickCheck}>
                    <td className="align-middle">
                        <input
                            type="checkbox"
                            name="checkboxOpModes"
                            data-idx={item.id}
                            value={item.id}
                        />
                    </td>
                    <td className="align-middle">{item.name}</td>
                    <td className="align-middle">{item.description}</td>
                    <td className="align-middle">{item.model}</td>

                </tr>
            ))}
            </tbody>
        </table>
    );
};

export default TableAdvanced;
